export const employment = [
    {   
        organization : "Lawrence Berkeley National Lab", 
        position: "Computer Systems Engineer II",
        start_date: "Jun 2022",
        end_date: "Present",
        location: "Berkeley, CA",
        description: 
            [
                "Design and development of React + Python applications to provide interfaces for water treatment models",
                "Deployment into desktop applications using Electron", 
                "Implementation of CI workflows to build, run, and test applications"
            ]
    }, 
    {   
        organization : "University of Arizona", 
        position: "Research Assistant",
        start_date: "Aug 2020",
        end_date: "May 2022",
        location: "Tucson, AZ",
        description: 
            [
                "Full stack design and development of a privacy web portal", 
                "Implemented a Django REST framework to handle billions of records in a NoSQL database"
            ]
    }, 
    {   
        organization : "Airforce Civilian Service (AFCS)", 
        position: "Computer Scientist, GS-1599-7",
        start_date: "May 2021",
        end_date: "Aug 2021",
        location: "Boston, MA",
        description: 
            [
                "Developed full stack web applications to help dashboard data science project", 
                "Utilized Kubernetes and a CI/CD pipeline to deploy applications to a production environment",
                "Implemented modern security protocols"
            ]
    },
    {   
        organization : "IBM Global Financing (IGF)", 
        position: "Application Developer",
        start_date: "Feb 2019",
        end_date: "Aug 2020",
        location: "Armonk, NY",
        description: 
            [
                "Frontend development on an IBM Global Financing web application", 
                "Developed and maintained over 200 automation scripts using Java and Selenium",
                "Implemented multi-threaded testing to increase automation efficiency",
                "Collaborated with a developers and analysts in an agile environment to ensure code quality standards and business requirements were met"
            ]
    }
]